import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { hopePatientSiaExists, mergeHopePatientSiaForUpdate } from '../hope';
import Request from './Request';
export class Workflow extends Request {
  constructor({
    agency: _agency,
    url,
    keycloak,
    signal
  }) {
    super({
      url,
      signal,
      keycloak
    });

    _defineProperty(this, "keycloak", void 0);

    _defineProperty(this, "commonHeaders", {
      Authorization: '',
      'Content-Type': 'application/json',
      Accept: 'application/json'
    });

    _defineProperty(this, "getPatientHIS", async (patientnumber, episodenum, agency) => {
      const response = await this.get({
        api: `/his/hispatientadmin/patient/${patientnumber}`,
        qs: {
          agency,
          episodenum
        }
      });
      return response;
    });

    _defineProperty(this, "getUnsentHIS", async agency => {
      const response = await this.get({
        api: `/his/hisadminevent/unsent`,
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getCrossPatientHIS", async (agency, site_id) => {
      const response = await this.get({
        api: `/his/hiscrosspatient`,
        qs: {
          agency,
          site_id
        }
      });
      return response;
    });

    _defineProperty(this, "postHISData", async (event, agency, method) => {
      const response = await this.post({
        api: `/his/hisadminevent`,
        data: event,
        method: method || 'POST',
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "postBatchHISData", async (site_id, events, agency, lastupdateuser, person_id, method) => {
      const response = await this.post({
        api: `/his/hisadminevent/unsentbatch`,
        data: events,
        method: method || 'POST',
        qs: {
          agency,
          site_id,
          lastupdateuser,
          person_id
        }
      });
      return response;
    });

    _defineProperty(this, "deleteHISAdminEvent", async (event_id, agency) => {
      const response = await this.post({
        api: `/his/hisadminevent/id/${event_id}`,
        method: 'DELETE',
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getCrossPatientHope", async (agency, siteId, patientNumber) => {
      const response = await this.get({
        api: `/hope/hopecrosspatientsummary`,
        qs: {
          agency,
          siteId,
          patientNumber
        }
      });
      return response;
    });

    _defineProperty(this, "getHopeReviewItems", async (patientNumber, episodenum, type, agency, site_id) => {
      const response = await this.get({
        api: `hope/hopereport/patient/${patientNumber}`,
        qs: {
          episodenum,
          agency,
          site_id,
          type
        }
      });
      return response;
    });

    _defineProperty(this, "getHopePatientDetails", async (patient_id, episodenum, agency, siteId) => {
      const response = await this.get({
        api: `/hope/hopepatientdetails/`,
        qs: {
          agency,
          siteId,
          patientId: patient_id,
          episodenum
        }
      });
      return response;
    });

    _defineProperty(this, "getHopePatientStatus", async (patient_id, episodenum, agency, siteId) => {
      const response = await this.get({
        api: `hope/hopepatientstatus/`,
        qs: {
          agency,
          siteId,
          patientId: patient_id,
          episodenum
        }
      });
      return response;
    });

    _defineProperty(this, "getHopePatientXML", async (patient_id, episodenum, milestone, agency, siteId) => {
      const response = await this.get({
        api: `/hope/hopereport/xml`,
        qs: {
          agency,
          siteId,
          patientid: patient_id,
          episodenum,
          milestone
        }
      });
      return response;
    });

    _defineProperty(this, "getBatchHopePatientXML", async (xmlData, agency, siteId) => {
      const response = await this.post({
        api: `/hope/batchhopedownloadxml`,
        qs: {
          agency,
          site_id: siteId
        },
        data: xmlData
      });
      return response;
    });

    _defineProperty(this, "getBatchHopeStatusUpdate", async (data, agency, siteId) => {
      const response = await this.post({
        api: `/hope/batchhopestatusupdate`,
        qs: {
          agency,
          siteId
        },
        data
      });
      return response;
    });

    _defineProperty(this, "getHopePatientSIA", async (patientVisitId, agency, siteId) => {
      const response = await this.get({
        api: `hope/hopepatientsia/get`,
        qs: {
          agency,
          siteId,
          patientvisitid: patientVisitId
        }
      });
      return response;
    });

    _defineProperty(this, "postSIAData", async (SIAData, agency, siteId) => {
      const response = await this.post({
        api: `hope/hopepatientsia/`,
        data: SIAData,
        qs: {
          agency,
          siteId
        }
      });
      return response;
    });

    _defineProperty(this, "saveHopePatientSIA", async (SIAData, agency, siteId) => {
      var _dto$patientVisitId;

      const dto = SIAData;
      const patientVisitId = `${(_dto$patientVisitId = dto.patientVisitId) !== null && _dto$patientVisitId !== void 0 ? _dto$patientVisitId : ''}`;
      const existing = patientVisitId ? await this.getHopePatientSIA(patientVisitId, agency, siteId) : null;
      const payload = hopePatientSiaExists(existing) ? mergeHopePatientSiaForUpdate(existing, dto) : SIAData;
      return this.postSIAData(payload, agency, siteId);
    });

    _defineProperty(this, "postHopeStatusUpdate", async (statusData, agency, siteId) => {
      const response = await this.post({
        api: `/hope/hopestatusupdate`,
        data: statusData,
        qs: {
          agency,
          siteId
        }
      });
      return response;
    });

    _defineProperty(this, "postHOPEData", async (event, agency, method) => {
      const response = await this.post({
        api: `/hope/hopeadminevent`,
        data: event,
        method: method || 'POST',
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "postSignedVerbalApproval", async (event, agency, method) => {
      const response = await this.post({
        api: `/approval/approvalverbalnotestatus`,
        data: event,
        method: method || 'POST',
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "postApproval", async (event, agency, method) => {
      const response = await this.post({
        api: `/approval/approval`,
        data: event,
        method: method || 'POST',
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "postApprovalNoteStatus", async (event, agency) => {
      const response = await this.post({
        api: `approval/approvalnotestatus`,
        data: event,
        method: 'PUT',
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "deleteApproval", async (event, agency) => {
      const response = await this.delete({
        api: '/approval/approvaldelete',
        data: event,
        method: 'DELETE',
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getApprovalById", async (id, agency) => {
      const response = await this.get({
        api: `/approval/approval/id/${id}`,
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getPhysicianApprovals", async (physicianPersonID, agency) => {
      const response = await this.get({
        api: `/approval/approvals/physician/${physicianPersonID}`,
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getPhysicianVerbalApprovals", async (physicianPersonID, agency, siteid) => {
      const response = await this.get({
        api: `/approval/approvals/physician/${physicianPersonID}`,
        qs: {
          agency,
          status: 'VA',
          siteid
        }
      });
      return response;
    });

    _defineProperty(this, "getAllApprovals", async agency => {
      const response = await this.get({
        api: `/approval/approvals`,
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getVerbalApprovals", async (agency, siteid) => {
      const response = await this.get({
        api: `/approval/approvals`,
        qs: {
          agency,
          status: 'VA',
          siteid
        }
      });
      return response;
    });

    _defineProperty(this, "getPatientApprovals", async (patientNumber, agency) => {
      const response = await this.get({
        api: `/approval/approvals/patient/${patientNumber}`,
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getPatientVAApprovals", async (patientNumber, agency) => {
      const response = await this.get({
        api: `/approval/approvals/patient/${patientNumber}`,
        qs: {
          agency,
          status: 'VA'
        }
      });
      return response;
    });

    _defineProperty(this, "refreshReviews", async agency => {
      const response = await this.post({
        api: `/approval/reviews/refresh`,
        headers: {
          Accept: 'text/html'
        },
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getCurrentReviews", async (reviewerPersonId, entitytype, agency) => {
      const response = await this.get({
        api: `/approval/reviews/reviewer/v2/${reviewerPersonId}`,
        qs: {
          status: 'RO',
          entitytype,
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getOldReviews", async (reviewerPersonId, fromdate, todate, entitytype, agency) => {
      const response = await this.get({
        api: `/approval/reviews/reviewer/v2/${reviewerPersonId}`,
        qs: {
          fromdate,
          todate,
          status: 'RW',
          entitytype,
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getEntityTypes", async agency => {
      const response = await this.get({
        api: `/approval/entitytypes`,
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "approveApproval", async (approval, agency) => {
      const response = await this.post({
        api: `/approval/approval`,
        data: JSON.stringify(approval),
        method: 'PUT',
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "addElectionAddendumTrigger", async (trigger, agency) => {
      const response = await this.post({
        api: `/electionaddendum/trigger`,
        data: trigger,
        method: 'POST',
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getElectionAddendumRequiredDate", async (patientId, agency) => {
      const response = await this.get({
        api: `/electionaddendum/requireddate/patient/${patientId}`,
        qs: {
          agency
        }
      });
      return response;
    });

    _defineProperty(this, "getOrderTypes", async agency => {
      const response = await this.get({
        api: `approval/entityordertypes`,
        qs: {
          agency
        }
      });
      return response;
    });

    this.url = new URL(url);
    this.keycloak = keycloak;

    if (_agency) {
      this.baseParams = {
        agency: _agency
      };
    }

    Object.defineProperty(this.commonHeaders, 'Authorization', {
      get() {
        const {
          token
        } = keycloak;
        return `Bearer ${token}`;
      },

      set(newValue) {// need a setter
      }

    });
    this.commonHeaders.Authorization = `Bearer ${keycloak.token}`;
  }

}
export default Workflow;